import { appPackagesStore } from "@app/static"

export function AppIcon30({packageName}: {packageName:string}){
    const packageInfo = appPackagesStore.findPackageInfoByPackageName(packageName)
    const image = packageInfo?.iconBase64 ? `data:image/gif;base64,${packageInfo.iconBase64}` : ''
    return <img src={image} width={30}
    style={{ borderRadius: '8px' }}
    />
}
